export default __webpack_public_path__ + "static/media/regulatory--no-parking--g9.b969233b.png";